import apiClient from '../shared/api/client';

export default function fetchWith403Redirect(url, options = {}) {
  return apiClient(url, options);
}
